import { useContext, useState, useCallback, useEffect } from "react";
import { MainContext } from "../context/main";
import * as constants from "../constants";

export default function useError() {
  const [removalPending, setRemovalPending] = useState(false);
  const { mainStore, mainDispatch } = useContext(MainContext);

  const dispatchError = useCallback(
    (error) =>
      mainDispatch({
        type: "MAIN_SET_ERROR",
        error,
      }),
    [mainDispatch]
  );

  const getRenderedError = useCallback(() => {
    if (mainStore.error) {
      if (mainStore.error === constants.GENERIC_ERROR) {
        return (
          <>
            <p>Something went wrong.</p>
            <p>
              Try again, or{" "}
              <a href="/support/ticket" target="_blank">
                file a ticket to report the bug
              </a>
            </p>
          </>
        );
      } else if (mainStore.error === constants.UNEXPECTED_ERROR) {
        return (
          <>
            <p>An unexpected error occured.</p>
            <p>
              Try again, or{" "}
              <a href="/support/ticket" target="_blank">
                file a ticket to report the bug
              </a>
            </p>
          </>
        );
      } else {
        if (typeof mainStore.error === "string") {
          return mainStore.error.split("\n").map((line) => {
            return <div key={line}>{line}</div>;
          });
        } else {
          return (
            <>
              <p>An unexpected error occured.</p>
              <p>
                Try again, or{" "}
                <a href="/support/ticket" target="_blank">
                  file a ticket to report the bug
                </a>
              </p>
            </>
          );
        }
      }
    } else {
      return null;
    }
  }, [mainStore.error]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const callbackGetError = useCallback(() => {}, [mainStore.error]);

  useEffect(() => {
    if (mainStore.error && !removalPending) {
      setRemovalPending(true);
      setTimeout(() => {
        dispatchError(null);
      }, 5000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mainStore.error]);

  return {
    getError: callbackGetError,
    error: mainStore.error,
    setError: dispatchError,
    getRenderedError,
  };
}
